import React from "react";
import { Alert } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as WarningSVG } from "go-core/images/svg/warning-alert.svg";
import { selectOrganization } from "go-security/services/organizations/selectors";

interface Props {
	displayKSeFUninstalledAlert?: boolean;
	displayNoOfflineCertAlert?: boolean;
}

export const InvoicePreviewKSeFAlert = ({ displayKSeFUninstalledAlert, displayNoOfflineCertAlert }: Props) => {
	const organization = useSelector(selectOrganization);

	if (!displayKSeFUninstalledAlert && !displayNoOfflineCertAlert) {
		return null;
	}

	const getAlertTranslationKey = () => {
		if (displayKSeFUninstalledAlert) return "modules.invoice.field.no_ksef_token_alert.title";
		if (displayNoOfflineCertAlert) return "modules.invoice.field.no_offline_cert_alert.title";

		return "";
	};

	return (
		<Alert variant="warning" className="d-flex align-items-center column-gap-3">
			<WarningSVG className="flex-shrink-0" />
			<p className="mb-0">
				<Trans
					i18nKey={getAlertTranslationKey()}
					components={[
						<Link
							to={`/${organization.id}/settings/info/invoice_details`}
							target="_blank"
							rel="noreferrer"
							key={0}
						/>,
					]}
				/>
			</p>
		</Alert>
	);
};

// t("modules.invoice.field.no_ksef_token_alert.title")
// t("modules.invoice.field.no_offline_cert_alert.title")
